<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ContractConfiguration')"
    width="960px"
    :close-on-click-modal="false"
  >
    <el-form :inline="true" label-width="70px" label-position="left">
      <!--合同规则配置-->
      <div style="height: 380px">
        <el-form-item style="display: block" :label="$t('CargoMsg.Cargo_ContractRule')" />
        <div style="display: flex">
          <!--合同规则-->
          <cargo-ag-grid
            style="width: 220px;margin-right: 20px;height:330px"
            :column-defs="ruleColumnDefs"
            :grid-options="ruleGridOptions"
            :row-data="ruleRowData"
            :show-side-bar="false"
          />
          <!--合同规则项-->
          <div style="width: 648px;">
            <!--规则名称-->
            <el-form-item style="display: block" :label="$t('SystemMaintenance.RuleName')">
              <el-input
                v-model="currentRule.name"
                style="width: 180px"
                maxlength="40"
                @input="p => {ruleGridOptions.api.refreshCells({ force: true });currentRule.isEdit=true}"
              />
            </el-form-item>
            <!--应用条件-->
            <el-form-item style="display: block" :label="$t('CargoMsg.Cargo_ApplicationConditions')">
              <cargo-advance-select
                style="width: 180px"
                :static-options="ruleModes"
                clearable
                tag-value="code"
                :default-value="currentRule.mode"
                :disabled="currentRule.existContract"
                required
                @parentCallBack="p=>{currentRule.mode=p.value;currentRule.isEdit=true}"
              />
            </el-form-item>
            <cargo-ag-grid
              :column-defs="ruleItemColumnDefs"
              :grid-options="ruleItemGridOptions"
              :row-data="currentRule.contractRuleItems"
              :show-side-bar="false"
              style="height:260px;padding-left: 70px"
            />
          </div>
        </div>
      </div>
      <div style="border-bottom: 2px solid #E3E3E3;margin-top: 10px;margin-bottom: 10px;" />
      <el-row>
        <el-col :span="24">
          <div>
            <span style="line-height: 25px; font-weight: bold;">{{ $t('CargoMsg.Cargo_ContractWarning') + '：' }}</span>
          </div>
          <el-form-item>
            <span style="margin-left: 20px;margin-right: 5px;">{{ $t('CargoMsg.Cargo_TimeLeftUntilExpiry') }}</span>
            <el-input-number
              v-model="contractConfig.warnDays"
              no="warnDays"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:70px;"
            />
            <span style="margin-left: 5px;">{{ $t('CargoMsg.Cargo_DayRemind') }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item class="form-item-check">
            <span style="margin-left: 20px;margin-right: 5px;">{{ $t('CargoMsg.Cargo_NotifyUser') + '：' }}</span>
            <br>
            <div style="padding-left: 20px;">
              <el-checkbox v-model="contractConfig.warnAdmin" no="warnAdmin" style="margin-right: 10px;" :title="$t('CargoMsg.Cargo_ContractAdministrator')">{{ $t('CargoMsg.Cargo_ContractAdministrator') }}</el-checkbox>
              <el-checkbox v-model="contractConfig.warnSale" no="warnSale" style="margin-right: 10px;" :title="$t('CargoMsg.Cargo_Sales')">{{ $t('CargoMsg.Cargo_Sales') }}</el-checkbox>
              <el-checkbox v-model="contractConfig.warnCustomerService" no="warnCustomerService" style="margin-right: 10px;" :title="$t('CargoMsg.Cargo_CustomerService')">{{ $t('CargoMsg.Cargo_CustomerService') }}</el-checkbox>
              <el-checkbox v-model="contractConfig.warnSupplierDirector" no="warnSupplierDirector" :title="$t('baseInfo.partner.supplierDirector')">{{ $t('baseInfo.partner.supplierDirector') }}</el-checkbox>
            </div>
            <span style="margin-left: 20px;margin-right: 5px;">{{ $t('CargoMsg.Cargo_NotifyMethod') + '：' }}</span>
            <br>
            <div style="padding-left: 20px;">
              <el-checkbox v-model="bellReminder" :disabled="true" no="bellReminder" style="margin-right: 10px;" :title="$t('CargoMsg.Cargo_Bell')">{{ $t('CargoMsg.Cargo_Bell') }}</el-checkbox>
              <el-checkbox v-model="contractConfig.mailReminder" no="mailReminder" style="margin-right: 10px;" :title="$t('CargoMsg.Cargo_Email2')">{{ $t('CargoMsg.Cargo_Email2') }}</el-checkbox>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <span style="line-height: 25px; font-weight: bold; color: red">{{ $t('CargoMsg.Cargo_NoteReminderMethod') }}</span>
      <div style="border-bottom: 2px solid #E3E3E3;margin-top: 10px;margin-bottom: 10px;" />
      <span style="line-height: 25px; font-weight: bold;">{{ $t('CargoMsg.Cargo_ProhibitBusinessConfiguration') }}</span>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-checkbox v-model="contractConfig.forbidCreate" no="forbidCreate" style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BWNBCAED') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button no="confirm" type="primary" :disabled="saveBtnEnabled" @click="saveEventHander">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { saveContractConfig } from '@/api/partner/contract'
import { ContractConfig } from '@/class/model/mdm/ContractConfig'
import { deepClone } from '@/utils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { DocumentManage } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoCascaderEditor from '@/components/Cargo/Common/CargoCascaderEditor'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { cacheKeys } from '@/utils/basicDataCache'
import $store from '@/store'
import { Assert } from '@/utils/validate'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import lodash from 'lodash'
import { FBA_JOBS } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'ContractConfigWindow',
  components: { CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    model: { type: Object, required: true, default: null }
  },
  data() {
    return {
      innerVisible: false,
      saveBtnEnabled: false,
      contractConfig: new ContractConfig().fillDefaultValue().getData(),
      documentManage: new DocumentManage(),
      ruleRowData: [], // 合同规则数据
      ruleGridOptions: {
        rowSelection: 'multiple',
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor
        },
        onRowClicked: this.onRuleRowSelected,
        onRowDoubleClicked: this.onRuleRowSelected
      },
      currentRule: null, // 当前选中规则
      ruleItemGridOptions: {
        rowSelection: 'multiple',
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoCascaderEditor
        }
      },
      // ruleItemRowData: [], // 合同规则项数据
      ruleModes: Array.from(SystemConstants.RULE_CONDITIONS), // 应用条件 下拉
      ruleColumns: Array.from(SystemConstants.CONTRACT_RULE_COLUMNS), // 条件项 下拉
      ruleOperators: Array.from(SystemConstants.CONTRACT_RULE_OPERATORS), // 条件规则 下拉
      ruleValuesLobs: Array.from(SystemConstants.CONTRACT_RULE_VALUES_LOBS), // 条件值 下拉【业务类型】
      bellReminder: true
    }
  },
  computed: {
    ruleColumnDefs() { // 合同规则显示列
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        },
        {
          headerName: this.$t('SystemMaintenance.RuleName'),
          field: 'name',
          width: 130,
          sortable: false
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 70,
          cellRenderer: params => {
            const onRuleAdd = this.documentManage.getPath('onRuleAdd')
            const onRuleDel = this.documentManage.getPath('onRuleDel')
            return `<div>
                        <a onclick="${onRuleAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onRuleDel}(${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          },
          sortable: false
        }]
    },
    ruleItemColumnDefs() { // 合同规则项显示列
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 25,
          sortable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ConditionalItem'),
          field: 'label',
          flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          width: 120,
          cellEditorParams: params => {
            return {
              selectProps: {
                filterable: true,
                disabled: this.currentRule.existContract
              },
              options: this.ruleColumns,
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              tagValue: 'code',
              style: 'width: 100%'
            }
          },
          cellRenderer: params => {
            const data = this.ruleColumns.filter(item => item.code === params.value)
            if (!data || data.length === 0) {
              return ''
            }
            return this.$store.getters.language === 'zh' ? data[0].chineseName : data[0].englishName
          },
          onCellValueChanged: (params) => {
            this.onRuleItemColumnCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConditionalRule'),
          field: 'operator',
          flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          width: 120,
          cellEditorParams: params => {
            return {
              options: this.ruleOperators,
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              tagValue: 'code',
              selectProps: {
                disabled: this.currentRule.existContract
              }
            }
          },
          cellRenderer: params => {
            const data = this.ruleOperators.filter(item => item.code === params.value)
            if (!data || data.length === 0) {
              return ''
            }
            return this.$store.getters.language === 'zh' ? data[0].chineseName : data[0].englishName
          },
          onCellValueChanged: (params) => {
            this.onRuleItemColumnCellChange(params)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConditionValue'),
          field: 'value',
          flex: 1,
          editable: true,
          width: 120,
          cellEditorSelector: params => {
            // 操作分公司
            if (params.data.label === SystemConstants.CONTRACT_RULE_COLUMN_OP_OFFICE.code) {
              return {
                component: 'CargoAgGridAdvanceSelectEditor',
                params: {
                  selectProps: {
                    selectType: TYPE_NAMES.basic_data_Office_All,
                    // tagValue: 'tagValue',
                    // tagName: 'code',
                    methodParams: {},
                    filterable: true,
                    disabled: this.currentRule.existContract
                  }
                }
              }
            }
            // 业务类型
            if (params.data.label === SystemConstants.CONTRACT_RULE_COLUMN_LOB.code) {
              return {
                component: 'CargoAgGridAdvanceSelectEditor',
                params: {
                  selectProps: {
                    tagValue: 'code',
                    tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
                    staticOptions: this.ruleValuesLobs,
                    filterable: true,
                    disabled: this.currentRule.existContract
                  }
                }
              }
            }
            // 自定义业务类型
            if (params.data.label === SystemConstants.CONTRACT_RULE_COLUMN_CUSTOM_JOB_TYPE.code) {
              return {
                component: 'CargoCascaderEditor',
                params: {
                  selectProps: {
                    selectType: TYPE_NAMES.basic_data_CutomJobType,
                    tagValue: 'uuid',
                    groupLabelMap: {
                      SE: this.$t('CargoMsg.Cargo_OceanExport'),
                      SI: this.$t('CargoMsg.Cargo_OceanImport'),
                      AE: this.$t('CargoMsg.Cargo_AirExport'),
                      AI: this.$t('CargoMsg.Cargo_AirImport'),
                      RE: this.$t('CargoMsg.Cargo_RailwayExport'),
                      RI: this.$t('CargoMsg.Cargo_RailwayImport'),
                      FBA_SE: this.$t('CargoMsg.Cargo_FbaSea'),
                      FBA_AE: this.$t('CargoMsg.Cargo_FbaAir'),
                      IE: this.$t('CargoMsg.Cargo_IntegratedJob')
                    },
                    filterNullKey: true,
                    disabled: this.currentRule.existContract
                  }
                }
              }
            }
            return {}
          },
          cellRenderer: params => {
            // 操作分公司
            if (params.data.label === SystemConstants.CONTRACT_RULE_COLUMN_OP_OFFICE.code) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
            }
            // 业务类型
            if (params.data.label === SystemConstants.CONTRACT_RULE_COLUMN_LOB.code) {
              return ColumnUtils.jobBussStateLabelContractRuleFunc(params.value)
            }
            // 自定义业务类型
            if (params.data.label === SystemConstants.CONTRACT_RULE_COLUMN_CUSTOM_JOB_TYPE.code) {
              const customJobTypes = ColumnUtils.getBasicDataCacheList(cacheKeys.basic_data_CutomJobType, item => item.uuid === params.value)
              const customJobType = customJobTypes ? customJobTypes[0] : null
              if (customJobType) {
                let type = customJobType.type
                if (customJobType.fba && SystemConstants.FBA_JOBS.indexOf(type) > -1) {
                  type = 'FBA_' + type
                }
                const lob = ColumnUtils.jobBussStateLabelContractRuleFunc(type)
                if ($store.getters.language === 'zh') {
                  return lob + '/' + customJobType.name || ''
                } else {
                  return lob + '/' + customJobType.englishName || ''
                }
              }
            }
            return ''
          },
          onCellValueChanged: (params) => {
            this.onRuleItemColumnCellChange(params)
          }
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'operation',
          suppressMenu: true,
          width: 70,
          cellRenderer: params => {
            const onRuleItemAdd = this.documentManage.getPath('onRuleItemAdd')
            const onRuleItemDel = this.documentManage.getPath('onRuleItemDel')
            return `<div>
                        <a onclick="${onRuleItemAdd}()" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onRuleItemDel}(${params.data.serialNumber})" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onRuleAdd', function() {
      context.onRuleAdd()
    })
    this.documentManage.set('onRuleDel', function(value) {
      context.onRuleDel(value)
    })
    this.documentManage.set('onRuleItemAdd', function() {
      context.onRuleItemAdd()
    })
    this.documentManage.set('onRuleItemDel', function(value) {
      context.onRuleItemDel(value)
    })
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      if (this.model) {
        this.contractConfig = deepClone(this.model)
        this.contractConfig.deleteRuleUuids = []
        if (this.contractConfig.contractRules && this.contractConfig.contractRules.length > 0) {
          this.ruleRowData = this.contractConfig.contractRules
          ColumnUtils.addSerialNumber(this.ruleRowData)
        } else {
          this.onRuleAdd()
        }
        this.currentRule = this.ruleRowData[0]
        ColumnUtils.addSerialNumber(this.currentRule.contractRuleItems)
      }
    },
    // 保存
    saveEventHander() {
      if (this.saveBtnEnabled) return
      this.$logger.log('this.contractConfig======保存之前', this.contractConfig)
      if (!this.checkContractRule()) {
        return
      }
      this.saveBtnEnabled = true
      this.loading = getLoading()
      const params = lodash.cloneDeep(this.contractConfig)
      if (params.contractRules && params.contractRules.length > 0) {
        params.contractRules = params.contractRules.filter(row => row.isEdit || !row.uuid)
      } else {
        params.contractRules = []
      }
      saveContractConfig(params).then(res => {
        this.$message.success(this.$t('Information.SavedSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        this.loading.close()
      })
    },
    checkContractRule() {
      const psInput = this.$t('CargoMsg.Cargo_PlsInput')
      if (this.ruleRowData.length === 1) {
        if (!this.ruleRowData[0].name) {
          if (this.ruleRowData[0].contractRuleItems.length === 1 &&
            !this.ruleRowData[0].contractRuleItems[0].label && !this.ruleRowData[0].contractRuleItems[0].operator &&
            !this.ruleRowData[0].contractRuleItems[0].value) {
            return true
          }
          Assert.isTrue(false, psInput + this.$t('SystemMaintenance.RuleName'))
          return false
        }
        this.contractConfig.contractRules = this.ruleRowData
        return this.checkContractRuleSingle(this.ruleRowData[0])
      }
      let result = true
      for (const rule of this.ruleRowData) {
        if (!this.checkContractRuleSingle(rule)) {
          result = false
          break
        }
      }
      this.contractConfig.contractRules = this.ruleRowData
      return result
    },
    checkContractRuleSingle(rule) {
      const psInput = this.$t('CargoMsg.Cargo_PlsInput')
      if (!rule.name) {
        Assert.isTrue(false, psInput + this.$t('SystemMaintenance.RuleName'))
        return false
      }
      if (!rule.mode) {
        Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_ApplicationConditions'))
        return false
      }
      let result = true
      for (const ruleItem of rule.contractRuleItems) {
        if (!ruleItem.label) {
          Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_ConditionalItem'))
          result = false
          break
        }
        if (!ruleItem.operator) {
          Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_ConditionalRule'))
          result = false
          break
        }
        if (!ruleItem.value) {
          Assert.isTrue(false, psInput + this.$t('CargoMsg.Cargo_ConditionValue'))
          result = false
          break
        }
      }
      return result
    },
    onRuleAdd() {
      const newRule = {
        name: '',
        mode: SystemConstants.RULE_CONDITIONS_ALL.code,
        contractRuleItems: [
          {
            label: '',
            operator: '',
            value: '',
            serialNumber: 1
          }
        ],
        existContract: false
      }
      this.ruleRowData.push(newRule)
      ColumnUtils.addSerialNumber(this.ruleRowData)
      this.currentRule = newRule
    },
    onRuleDel(serialNumber) {
      const deletedRule = this.ruleRowData.filter(row => row.serialNumber === serialNumber)
      // 禁止编辑 存在合同的规则
      if (deletedRule[0].existContract) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContractRuleChangeTip'))
        return
      }
      // 记录 删除的规则
      if (deletedRule[0].uuid) {
        this.contractConfig.deleteRuleUuids = [...this.contractConfig.deleteRuleUuids, deletedRule[0].uuid]
      }
      this.ruleRowData = this.ruleRowData.filter(row => row.serialNumber !== serialNumber)
      if (this.ruleRowData.length === 0) {
        this.onRuleAdd()
      } else {
        ColumnUtils.addSerialNumber(this.ruleRowData)
        this.currentRule = this.ruleRowData[0]
      }
    },
    onRuleItemAdd() {
      // 禁止编辑 存在合同的规则
      if (this.currentRule.existContract) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContractRuleChangeTip'))
        return
      }
      const newRuleItem = {
        label: '',
        operator: OperatorConstants.OPERATOR_EQUAL.code,
        value: ''
      }
      this.currentRule.contractRuleItems.push(newRuleItem)
      ColumnUtils.addSerialNumber(this.currentRule.contractRuleItems)
    },
    onRuleItemDel(serialNumber) {
      if (this.currentRule.uuid) {
        // 记录 修改的规则
        this.currentRule.isEdit = true
      }
      // 禁止编辑 存在合同的规则
      if (this.currentRule.existContract) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ContractRuleChangeTip'))
        return
      }
      const deletedRuleItem = this.currentRule.contractRuleItems.filter(row => row.serialNumber === serialNumber)
      // 记录 删除的规则
      if (deletedRuleItem[0].uuid) {
        this.currentRule.deleteRuleItemUuids = [...this.currentRule.deleteRuleItemUuids, deletedRuleItem[0].uuid]
      }
      this.currentRule.contractRuleItems = this.currentRule.contractRuleItems.filter(row => row.serialNumber !== serialNumber)
      if (this.currentRule.contractRuleItems.length === 0) {
        this.onRuleItemAdd()
      } else {
        ColumnUtils.addSerialNumber(this.currentRule.contractRuleItems)
      }
    },
    onRuleItemColumnCellChange(params) {
      // console.log('params:' + JSON.stringify(params.data))
      // console.log('params:' + params.value)
      if (params.newValue === params.oldValue) {
        return
      }
      if (this.currentRule.uuid) {
        // 记录 修改的规则
        this.currentRule.isEdit = true
      }
      if (params.colDef.field === 'label') {
        params.data.value = ''
      }
      if (params.data.uuid) {
        // 记录 修改的规则项
        params.data.isEdit = true
      }
      this.ruleItemGridOptions.api.refreshCells({ force: true })
    },
    onRuleCellChange(params) {
      if (params.newValue === params.oldValue) {
        return
      }
      if (this.currentRule.uuid) {
        // 记录 修改的规则
        this.currentRule.isEdit = true
      }
    },
    onRuleRowSelected(event) {
      // console.log('event.data:', JSON.stringify(event.data))
      this.currentRule = event.data
      ColumnUtils.addSerialNumber(this.currentRule.contractRuleItems)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-check /deep/ .el-checkbox__label{
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: -6px;
}
</style>
